module.exports = __webpack_public_path__ + "img/people-sitting-inside-a-restaurant-3252051.8a5666fe.jpg";